export function mongoObjectIdToDate (value) {
    const temp = new Date(parseInt(value.substring(0, 8), 16) * 1000);
    return temp.toISOString();
}

export default mongoObjectIdToDate;
